import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.scss';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import POS from './pages/POS';
import Inventory from './pages/Inventory';
import Reports from './pages/Reports';
import EmployeePortal from './pages/EmployeePortal';
import Customers from './pages/Customers';
import PrivateRoute from './components/PrivateRoute';
import Profile from './pages/Profile';
import AccountSettings from './pages/AccountSettings';
import ActivityLog from './pages/ActivityLog';
import Categories from './pages/Categories';
import SoldProducts from './pages/SoldProducts';
import Team from './pages/Team';
import Suppliers from './pages/Suppliers';
import Expenses from './pages/Expenses';
import Returns from './pages/Returns';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import Settings from './pages/Settings';
import EmployeeSalary from './pages/EmployeeSalary';
import ForgotPassword from './pages/ForgotPassword';

import { Toaster } from 'react-hot-toast';

function App() {
  React.useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-bs-theme', savedTheme);
  }, []);

  return (
    <Router>
      <Toaster position="top-right" />
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/pos" element={<POS />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/sold-products" element={<SoldProducts />} />
            <Route path="/employees" element={<EmployeePortal />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/account-settings" element={<AccountSettings />} />
            <Route path="/activity-log" element={<ActivityLog />} />
            <Route path="/team" element={<Team />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/employee-salary" element={<EmployeeSalary />} />
            <Route path="/super-admin" element={<SuperAdminDashboard />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
